/** * @author SwathiDivya Bhavaraju * @email swathidivya.bhavaraju@ul.com * @create date 2021-01-05
13:12:12 * @modify date 2021-01-05 13:12:12 * @desc [description] */\\
<template>
  <div class="content-wrappper">
    <div class="sales-container">
      <div class="col-xs-12">
        <router-link class="sub-heading cursor-pointer" to="/layout/launchpad">
          <i class="fa fa-angle-left"></i>Add {{ roleDetails.role_name || '' }}
        </router-link>
        <div class="row m-0 mb-15">
          <div class="note">
            Note: {{ roleDetails.role_name || '' }} user will have access to all the REP accounts by
            default.
          </div>
        </div>
        <div class="row m-0 mt-25">
          <div class="col-xs-12 form-group">
            <label>Role</label>
          </div>
          <div class="col-xs-12 col-sm-8 col-md-6 mb-25">
            <input type="text" class="form-control" v-model="roleDetails.role_name" readonly />
          </div>
          <div class="col-xs-12 form-group">
            <label>First Name</label>
          </div>
          <div class="col-xs-12 col-sm-8 col-md-6 mb-25">
            <input
              type="text"
              class="form-control"
              placeholder="Name"
              v-model="repConsultant.first_name"
              maxlength="35"
            />
          </div>
          <div class="col-xs-12 form-group">
            <label>Last Name</label>
          </div>
          <div class="col-xs-12 col-sm-8 col-md-6 mb-25">
            <input
              type="text"
              class="form-control"
              placeholder="Name"
              v-model="repConsultant.last_name"
              maxlength="35"
            />
          </div>
          <div class="col-xs-12 form-group">
            <label>Email</label>
          </div>
          <div class="col-xs-12 col-sm-8 col-md-6 mb-25">
            <div class="col-xs-12 p-0">
              <input
                type="text"
                class="form-control"
                :class="
                  (repConsultant.email && repConsultant.email.length < 2) ||
                  (repConsultant.email && repConsultant.email.length > 1 && !validEmail) ||
                  emailExists
                    ? 'invalid-border'
                    : ''
                "
                placeholder="Email"
                v-model="repConsultant.email"
                @change="validateEmail"
                maxlength="65"
              />
            </div>
            <div class="col-xs-12 p-0">
              <div
                class="custom-error-class"
                v-if="repConsultant.email && repConsultant.email.length < 2"
              >
                Please enter at least 2 characters for email.
              </div>
              <div
                class="custom-error-class"
                v-if="repConsultant.email && repConsultant.email.length > 1 && !validEmail"
              >
                Please enter a valid email address.
              </div>
              <div class="custom-error-class" v-if="emailExists">
                Email already registered with the account.
              </div>
            </div>
          </div>
          <!-- <div class="row button-margin"> -->
          <div
            class="col-xs-offset-1 col-xs-10 col-sm-offset-6 col-sm-5 col-md-offset-6 col-md-5 col-lg-offset-8 col-lg-3"
          >
            <button
              type="button"
              class="btn btn-block emergo-green-button"
              :disabled="disableButtonForAddTeam || loaderStatus"
              @click="addRepConsultant()"
            >
              Save Changes
            </button>
          </div>
        </div>
      </div>
      <!-- </div> -->
    </div>
    <loader :loadingStatus="loaderStatus"></loader>
  </div>
</template>
<script>
import Loader from '../UIComponents/Loader.vue';
import { addRepConsultant } from '../../apis/repRoles';
import { getListOfRoles } from '../../apis/rbac';

export default {
  data() {
    return {
      repConsultant: {
        first_name: '',
        last_name: '',
        email: '',
        role_id: 15
      },
      loaderStatus: false,
      roleDetails: {},
      emailExists: false,
      validEmail: true
    };
  },
  components: {
    Loader
  },
  watch: {
    repConsultant: {
      deep: true,
      immediate: true,
      handler(currentValue) {
        if (
          currentValue.first_name.length < 2 ||
          currentValue.last_name.length < 2 ||
          currentValue.email.length < 2
        ) {
          this.userList = [];
        }
      }
    }
  },

  methods: {
    clearNotifications() {
      this.$notify({
        clear: true,
        group: 'custom-notification'
      });
    },
    validateEmail() {
      const mailformat = /^([a-zA-Z0-9_\-\+\.]+)@([a-zA-Z-0-9-]+)((\.([a-zA-Z0-9-]){2,63}){1,3})$/; // eslint-disable-line
      if (mailformat.test(this.repConsultant.email)) {
        this.validEmail = true;
        return true;
      }
      this.validEmail = false;
      return false;
    },
    async getRoles() {
      this.loaderStatus = true;
      this.roleDetails = (await getListOfRoles()).find(
        (role) => role.role_id === this.repConsultant.role_id
      ); // eslint-disable-line
      this.loaderStatus = false;
    },
    async addRepConsultant() {
      this.loaderStatus = true;
      const response = await addRepConsultant(this.repConsultant);
      this.loaderStatus = false;
      if (response.status_code === 200 && response.message === 'success') {
        this.clearNotifications();
        this.$notify({
          type: 'success',
          title: 'Success',
          text: `${this.roleDetails.role_name} user created successfully`,
          group: 'custom-notification'
        });
        this.repConsultant = {
          ...this.repConsultant,
          ...{
            first_name: '',
            last_name: '',
            email: '',
            role_id: 15
          }
        };
      } else {
        this.clearNotifications();
        this.$notify({
          type: 'error',
          title: 'Error',
          text:
            response.status_code === 200 && response.message === 'failed'
              ? response.data
              : `Unable to create ${this.roleDetails.role_name} user!`,
          group: 'custom-notification'
        });
      }
    }
  },
  computed: {
    disableButtonForAddTeam() {
      if (
        this.repConsultant.first_name &&
        this.repConsultant.last_name &&
        this.repConsultant.email &&
        this.validateEmail()
        // && !this.emailExists
      ) {
        return false;
      }
      return true;
    }
  },
  created() {
    this.getRoles();
  }
};
</script>
<style scoped lang="scss">
.sales-container {
  padding: 25px 20px;
}
.sub-heading {
  > i {
    margin-right: 6px;
  }
  font-family: $font-family-roboto;
  font-style: normal;
  font-size: 18px;
  color: $primary;
}
.note {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  padding-top: 15px;
  color: rgba(0, 0, 0, 0.7);
}
.form-group {
  margin-bottom: 2px;
}
</style>
